import styled from 'styled-components';

import { spaceMixin, token } from '@zillow/constellation';

export const StyledBackgroundDiv = styled.div<{ isActiveProductTypeFree?: boolean; isLoading?: boolean }>`
  cursor: pointer;
  background-color: ${({ isActiveProductTypeFree }) =>
    isActiveProductTypeFree ? token('colors.coolGray100') : token('colors.coolGray200')};
  padding: ${spaceMixin('sm')};
`;
